<template>
  <div class="row">
    <div class="col">
      <div class="row">
        <div class="col-4 lbl">
          <label>Secteur :</label>
        </div>
        <div class="col-4">
          <Dropdown
            v-model="secteur"
            :options="secteurLibelles"
            :showClear="true"
            :filter="true"
            optionValue="valeur"
            optionLabel="texte"
            scrollHeight="205px"/>
        </div>
      </div>
    </div>
  </div>
  <div class="row"/>
  <div v-if="isRechercheDataLoading == true" class="row">
    <div class="col">
      <vue-loaders name="ball-beat" class="justify-center"></vue-loaders>
    </div>
  </div>
  <div v-else class="row">
    <div class="col">
      <Button @click="rechercher"> Rechercher </Button>
    </div>
    <div class="col" >
      <Button @click="redirectionRechercherCategorie"> Recherche catégorie </Button>
    </div>
    <div class="col" >
      <Button @click="redirectionAjouterRegroupement"> Ajouter </Button>
    </div>
    <div class="col">
      <Button @click="fermer"> Fermer </Button>
    </div>
  </div>
</template>

<script>

export default {
  props: ['secteurLibelles', 'isRechercheDataLoading'],
  emits: ['rechercher'],
  data() {
    return {
      secteur: null
    }
  },
  methods: {
    redirectionAjouterRegroupement() {
      this.$router.push({name: "ajouterRegroupement"});
    },
    redirectionRechercherCategorie() {
      this.$router.push({name: "rechercherCategorieRegroupement"});
    },
    rechercher(){
      let libelle = {};
      libelle.valeur = this.secteur;
      this.$emit('rechercher', libelle);
    },
    fermer() {
      this.$root.$refs.breadcrumbComp.rediriger();
    }
  }
}
</script>
